import AxiosClient from "../../../services/axios.services";

class DescriptorValidationServices {
  getDescriptorValidation = (params, onlyGeneralData, carreer) =>
    AxiosClient.get(
      carreer
        ? "/api/app/carrera_sucesion_validacion_descriptor"
        : onlyGeneralData
        ? "/api/app/seleccion_contratacion_validacion_descriptor_datos_generales"
        : "/api/app/seleccion_contratacion_validacion_descriptor/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
}

export default new DescriptorValidationServices();
